import { Link, useLocation } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { IoIosArrowBack, IoIosArrowDown, IoMdChatboxes } from "react-icons/io";
import { useEffect, useState } from "react";
import { useRole } from "../store";
import { MdOutlineDashboardCustomize } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import { FaCircle } from "react-icons/fa";

export default function Sidebar() {
  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const isMonitor = useRole((state) => state?.isMonitor);
  const [isReportsOpen, setIsReportsOpen] = useState(false);

  useEffect(() => {
    setActive(pathname.split("/")[1]);
    if (pathname.startsWith("/report")) {
      setIsReportsOpen(true);
    }
  }, [pathname]);

  const toggleReportsDropdown = () => {
    setIsReportsOpen(prevState => {
      return !prevState;
    });
  };

  return (
    <div className="sidebar-dark-primary d-lg-none">
      <aside className="main-sidebar sidebar-dark-primary elevation-1">
        <Link to="/" className="brand-link">
          <img
            src={process.env.REACT_APP_BASE_PATH + "/dist/img/AdminLTELogo.png"}
            alt="AdminLTE Logo"
            className="brand-image img-circle elevation-3"
            style={{ opacity: ".8" }}
          />
          <span className="brand-text font-weight-light">User Panel</span>
        </Link>

        <div className="sidebar">
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Monitor Dashboard */}
              {isMonitor ? (
                <li className="nav-item">
                  <Link
                    to="/"
                    className={`nav-link d-flex align-items-center ${active === "" ? "active" : ""
                      }`}
                  >
                    <MdOutlineDashboardCustomize className="nav-icon" />
                    <p>Monitor Dashboard</p>
                  </Link>
                </li>
              ) : (
                < li className="nav-item">
                  <Link
                    to="/"
                    className={`nav-link d-flex align-items-center ${active === "" ? "active" : ""
                      }`}
                  >
                    <MdDashboard className="nav-icon" />
                    <p>Dashboard</p>
                  </Link>
                </li>
              )}

              {/* Chat Box */}
              <li className="nav-item">
                <Link
                  to="/chat-box/campaigns"
                  className={`nav-link d-flex align-items-center ${active === "chat-box" ? "active" : ""
                    }`}
                >
                  <IoMdChatboxes className="nav-icon" />
                  <p>Chat Box</p>
                </Link>
              </li>

              {/*=========== Reports-Section-Start=== */}
              <li className='nav-item'>
                <div
                  className={`nav-link d-flex align-items-center flex-nowrap ${pathname.startsWith("/report") ? "active" : ""}`}
                  onClick={toggleReportsDropdown}
                  style={{ cursor: 'pointer', color: '#C2C7D0' }}
                >
                  <TbReportAnalytics className='nav-icon' />
                  <p className="d-flex justify-content-between flex-grow-1 align-items-center">
                    <span>Reports</span>
                    {isReportsOpen ? <IoIosArrowDown /> : <IoIosArrowBack />}
                  </p>
                </div>

                {/* Submenu with conditional render and transition */}
                <ul className={`nav nav-treeview ${isReportsOpen ? 'open' : 'close'}`}>
                  {isMonitor && isMonitor ? (
                    <>
                      <li className="nav-item">
                        <Link
                          to="/report/agent-wise"
                          className={`nav-link d-flex align-items-center ${active === "/report/agent-wise" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>Agent Wise Unique Customer Reports</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/report/sms-conversion"
                          className={`nav-link d-flex align-items-center ${active === "/report/sms-conversion" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>SMS Conversion Reports</p>
                        </Link>
                      </li>
                      {/* <li className="nav-item">
                        <Link
                          to="/report/sms-conversion-report/campaign-list"
                          className={`nav-link d-flex align-items-center ${active === "/report/sms-conversion-report/campaign-list" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>SMS Conversion Reports - 2</p>
                        </Link>
                      </li> */}
                      <li className="nav-item">
                        <Link
                          to="/report/campaign-wise/campaign-list"
                          className={`nav-link d-flex align-items-center ${active === "/report/campaign-wise/campaign-list" || active === "/report/campaign-wise" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>Campaign Wise Report</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/report/custom"
                          className={`nav-link d-flex align-items-center ${active === "/report/custom" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>Custom Report</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/report/customer-wise/campaign-list"
                          className={`nav-link d-flex align-items-center ${active === "/report/customer-wise/campaign-list" || active === "/report/customer-wise" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>Customer Wise Report</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/report/incoming-outgoing/campaign-list"
                          className={`nav-link d-flex align-items-center ${active === "/report/incoming-outgoing/campaign-list" || active === "/report/incoming-outgoing" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>Incoming & Outgoing Report</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/report/day-wise/campaign-list"
                          className={`nav-link d-flex align-items-center ${active === "/report/day-wise/campaign-list" || active === "/report/day-wise" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>Day Wise Report</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/report/agent-wise-day-month/campaign-list"
                          className={`nav-link d-flex align-items-center ${active === "/report/agent-wise-day-month/campaign-list" || active === "/report/agent-wise-day-month" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>Agent Wise (D-W-M) Report</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/report/disposition-status/campaign-list"
                          className={`nav-link d-flex align-items-center ${active === "/report/disposition-status/campaign-list" || active === "/report/disposition-status" ? "active" : ""}`}
                        >
                          <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                          <p>Disposition Status Report</p>
                        </Link>
                      </li>
                    </>
                  ) : ("")}

                  <li className="nav-item">
                    <Link
                      to="/report/history"
                      className={`nav-link d-flex align-items-center ${active === "/report/history" ? "active" : ""}`}
                    >
                      <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                      <p>SMS History Report Reports</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/report/one-to-one/campaign-list"
                      className={`nav-link d-flex align-items-center ${active === "/report/one-to-one/campaign-list" || active === "/report/one-to-one" ? "active" : ""}`}
                    >
                      <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                      <p>One To One Report</p>
                    </Link>
                  </li>
                </ul>
              </li>
              {/*=========== Reports-Section-End=== */}
            </ul>
          </nav>
        </div>
      </aside >
    </div >
  );
}
